<template>
  <div class="card">
    <div class="echartHead">
      <h3>人员入场情况</h3>
      <a-space>
        <div class="w" :class="{ wa: type == '1' }" @click="change(1)">
          本周
        </div>
        <div class="w" :class="{ wa: type == '2' }" @click="change(2)">
          本月
        </div>
        <div class="w" :class="{ wa: type == '3' }" @click="change(3)">
          近六月
        </div>
      </a-space>
    </div>
    <div id="echart1"></div>
  </div>
</template>

<script>
import * as echarts from "echarts"; // 导入echarts
import elementResizeDetectorMaker from "element-resize-detector";
const erd = elementResizeDetectorMaker();
export default {
  data() {
    return {
      myChart: null,
      type: 3,
      option: {},
    };
  },
  props: {},
  watch: {
    // option.series[0].data[2] = 50;
    // arr:{
    //   handler(newV, oldV){
    //   }
    // }
  },
  mounted() {
    this.myChart = echarts.init(document.getElementById("echart1"));
    this.getLoadEcharts();
    erd.listenTo(document.getElementById("echart1"), () => {
      this.$nextTick(() => {
        //使echarts尺寸重置
        this.myChart.resize();
      });
    });
    this.$emit("change", this.type);
  },
  destroyed() {
    erd.uninstall(this.$refs.canvas);
  },
  methods: {
    change(type) {
      if (this.type == type) return;
      this.type = type;
      this.$emit("change", this.type);
    },
    getLoadEcharts() {
      this.option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            margin: 20,
            color: "#585F6A",
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#D5D8E5",
              width: "1",
            },
          },
          // 去掉x轴那个小点点的显示
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            margin: 30,
          },
        },
        grid: {
          left: "80",
          top: "30",
          right: "30",
          bottom: "50",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              width: 1,
              type: "solid",
              color: "#0073FF",
              opacity: 0.2,
            },
          },
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          },
        },
        formatter: function (params) {
          return (
            '<div style="padding: 4px 40px 4px 5px"><p style="color: #9BA2AB;font-size: 12px;margin: 0;padding-bottom: 3px;">入场人数</p><p style="color: #011733;font-size: 18px;font-weight: 600;margin: 0">' +
            params[0].data +
            "</p></div>"
          );
        },
        series: [
          {
            data: [],
            type: "line",
            color: "rgba(0, 115, 255, 0.5)",
            smooth: true,
            showSymbol: false,
            symbol: "emptyCircle",
            symbolSize: 10,
            itemStyle: {
              borderColor: "rgba(0, 115, 255, 0.5)",
              borderWidth: 3,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(0, 115, 255, 0.6)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 115, 255, 0)",
                },
              ]),
            },
          },
        ],
      };
      this.draw();
    },
    draw() {
      this.myChart.setOption(this.option);
    },
  },
};
</script>

<style>
</style>